import script from "./OCalendario.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCalendario.vue?vue&type=script&lang=ts&setup=true"

import "./OCalendario.vue?vue&type=style&index=0&id=304042e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304042e8"]])

export default __exports__